var map = {
	"./arrow-left.svg": "b802",
	"./caret-down.svg": "18cf",
	"./cookie.svg": "16fd",
	"./map-with-pin.svg": "c0e7",
	"./menu.svg": "5f13",
	"./online-shop.png": "51f3",
	"./pin-regular-alternate.svg": "e670",
	"./pin-regular.svg": "1482",
	"./pin-transparent.svg": "7a11",
	"./sg-bg.jpg": "0045"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95e3";